export const CustomLogTag = {
    // 0,1,2 are reserved by Wonderland Engine
    Game: 3,
};
